export default __webpack_public_path__ + "static/hall-c4c66e6827c0e7d8eff2367627349ddd.jpeg";